import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Stack } from 'react-bootstrap';
import PaginationBox from 'components/PaginationBox';
import { useApplicantsListMutation, useJobDetailsQuery } from 'services';
import { dataLimits } from 'constants/index';
import { Link, useParams } from 'react-router-dom';
import CandidateDetailBox from 'components/Common/Candidates/CandidateDetailBox';
import useSkeleton from 'hooks/useSkeleton';
import CandidateDetailSkeleton from 'components/Common/Skeleton/CandidateDetailSkeleton';
import useTranslate from 'hooks/useTranslate';
import './styles.scss';

const ApplicantsList: React.FC = () => {
	const { translate } = useTranslate();
	const [currentPage, setCurrentPage] = useState(1);
	const { id } = useParams<any>();
	const queryOptions = `jobId=${id}&limit=${dataLimits?.applicantsListing}&page=${currentPage}`;
	const { data: { docs: jobs = [], meta = {} } = [], refetch } =
		useApplicantsListMutation(queryOptions);
	const { limit = 10, totalDocs } = meta;
	const { data: job = {} } = useJobDetailsQuery(id);
	const [isLoading, setIsLoading] = useState<boolean>(true);
	const delayedLoading = useSkeleton(isLoading);

	useEffect(() => {
		setIsLoading(true);
		refetch().finally(() => {
			setIsLoading(false);
		});
	}, [currentPage]);

	return (
		<section className="applicants-list py-50 hiring-board">
			<Container fluid>
				<div className="mb-3">
					<Link to="/company/my-jobs" className="back-link">
						<i className="ri-arrow-left-line"></i> Back to List
					</Link>
				</div>
				<h4 className="fw-bold mb-4">{[job?.title, job?.cityName].filter(Boolean).join(', ')}</h4>

				<div className="white-box bg-white">
					<h5 className="mb-2 mb-md-4">
						{totalDocs} {translate('JobDetailBox.applicants')}
					</h5>
					<Row className="applicants-list-row">
						{delayedLoading ? (
							<CandidateDetailSkeleton />
						) : (
							<>
								{jobs?.length > 0 ? (
									jobs?.map((item: any) => (
										<Col lg={6} key={`${item?.userId}-${item?.name}`}>
											<CandidateDetailBox
												aboutUs={false}
												applicantList={item}
												jobId={id}
												jobTitle={job?.title}
												actions={true}
												refetch={refetch}
											/>
										</Col>
									))
								) : (
									<Stack>{translate('Common.noRecord')}</Stack>
								)}
							</>
						)}
					</Row>

					{totalDocs > limit && (
						<PaginationBox
							totalData={totalDocs}
							limit={limit}
							page={currentPage}
							setCurrentPage={setCurrentPage}
						/>
					)}
				</div>
			</Container>
		</section>
	);
};

export default ApplicantsList;
